import { Blac } from "blac-next";
import React, { useRef } from "react";
import BlockingLoadingOverlayController from "../BlockingLoadingOverlay/BlockingLoadingOverlayController";
import AppDebugCubit from "./AppDebugCubit";
import { DebugButton, DebugButtonRow, DebugFormGroup } from "./debug.styles";

// Auto-collapse the debug panel so the loading overlay we just triggered is
// actually visible.
const minifyDebugPanel = (): void => {
  Blac.getBloc(AppDebugCubit).setMinified(true);
};

const DebugLoadingOverlay = () => {
  const titleRef = useRef<HTMLInputElement>(null);
  const messageRef = useRef<HTMLInputElement>(null);

  const getValues = () => ({
    title: titleRef.current?.value || undefined,
    message: messageRef.current?.value || undefined
  });

  return (
    <div>
      <DebugFormGroup>
        <label>Overlay Title</label>
        <input ref={titleRef} type="text" placeholder="e.g. Processing..." />
      </DebugFormGroup>
      <DebugFormGroup>
        <label>Overlay Message</label>
        <input ref={messageRef} type="text" placeholder="e.g. Please wait" />
      </DebugFormGroup>

      <DebugButtonRow style={{ marginTop: "0.75rem" }}>
        <DebugButton
          onClick={() => {
            BlockingLoadingOverlayController.startLoading({
              bg: "transparent",
              ...getValues()
            });
            minifyDebugPanel();
          }}
        >
          Show Loading
        </DebugButton>
        <DebugButton
          onClick={() => {
            BlockingLoadingOverlayController.loadingSuccess(getValues());
            minifyDebugPanel();
          }}
        >
          Show Success
        </DebugButton>
        <DebugButton
          className="danger"
          onClick={() => {
            BlockingLoadingOverlayController.loadingError(getValues());
            minifyDebugPanel();
          }}
        >
          Show Error
        </DebugButton>
        <DebugButton
          onClick={() => BlockingLoadingOverlayController.endLoading()}
        >
          Dismiss
        </DebugButton>
      </DebugButtonRow>
    </div>
  );
};

export default DebugLoadingOverlay;
